import React from "react";
import {FormattedMessage} from "react-intl";
import classes from "./styles.module.css";

const Empty = () => {
    return (
        <table className={classes.Table}>
            <tbody>
            <tr>
                <td>
                    <div className={classes.Empty}>
                        <h5>
                            <FormattedMessage id="Empty.message.dataSoon" defaultMessage="Данные скоро появятся"/>
                        </h5>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    );
};

export default Empty;



// WEBPACK FOOTER //
// ./src/Components/CountryWidget/Empty.js